import { render } from "./AcceptDecline.vue?vue&type=template&id=18cbab7e&scoped=true"
import script from "./AcceptDecline.vue?vue&type=script&lang=js"
export * from "./AcceptDecline.vue?vue&type=script&lang=js"

import "./AcceptDecline.vue?vue&type=style&index=0&id=18cbab7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18cbab7e"]])

export default __exports__